export default __webpack_public_path__ + "962e67b1a77aaa5695c36a76dc2713a4.png";